import React, { useMemo } from 'react';
import { InputWithUnitField, TextField } from '../../../components/Form';
import { useFocusIdx } from '@bay-email/editor';
import { Grid } from '@arco-design/web-react';

export function Border() {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    return (
      <>
        <TextField label={t('Border')} name={`${focusIdx}.attributes.border`} />
        <InputWithUnitField
          label={t('Border Radius')}
          name={`${focusIdx}.attributes.border-radius`}
          unitOptions='percent'
        />
      </>
    );
  }, [focusIdx]);
}
